export const converterStringBooleanParaBoolean = (value: string | boolean):boolean => 
typeof value === 'string' 
? value.toLowerCase() === 'true' 
: value